"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAsyncContextStrategy = getAsyncContextStrategy;
exports.setAsyncContextStrategy = setAsyncContextStrategy;

var _carrier = require("../carrier.js");

var _stackStrategy = require("./stackStrategy.js");

/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */
function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  const registry = (0, _carrier.getMainCarrier)();
  const sentry = (0, _carrier.getSentryCarrier)(registry);
  sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */


function getAsyncContextStrategy(carrier) {
  const sentry = (0, _carrier.getSentryCarrier)(carrier);

  if (sentry.acs) {
    return sentry.acs;
  } // Otherwise, use the default one (stack)


  return (0, _stackStrategy.getStackAsyncContextStrategy)();
}